import { render, staticRenderFns } from "./ScheduleServices.vue?vue&type=template&id=61f23e67"
import script from "./ScheduleServices.vue?vue&type=script&lang=js"
export * from "./ScheduleServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ScheduleServices.vue?vue&type=custom&index=0&blockType=i18n&locale=ru&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dem/Go/src/github.com/demget/quadroclub/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('61f23e67', component.options)
    } else {
      api.reload('61f23e67', component.options)
    }
    module.hot.accept("./ScheduleServices.vue?vue&type=template&id=61f23e67", function () {
      api.rerender('61f23e67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "site/src/views/schedule/ScheduleServices.vue"
export default component.exports